import { WebCamActionTypes } from "./types"

export const setWebCamElement = (webCamElement: HTMLVideoElement) => {return {type: WebCamActionTypes.SET_WEBCAM_ELEMENT, webCamElement}}